// src/api/mockClient.js
import api from "./api"; // your existing axios instance

export const getMyQuestions = () => api.get("/mock/questions"); // removed extra /api
export const startMockInterview = (payload) => api.post("/mock/start", payload); // { mode: "mixed" } or { mode: "domain", domain: "Cloud" }
export const submitMockAnswer = (payload) => api.post("/mock/answer", payload); // { mockInterviewId, questionId, answerText, timeTakenSec }
export const endMockInterview = (interviewId) => api.post(`/mock/end/${interviewId}`);
export const getMockReport = (interviewId) => api.get(`/mock/report/${interviewId}`);

// 🔥 New: Retake interview (use same questions again)
export const  retakeInterview = (interviewId) =>
  api.post(`/mock/retake/${interviewId}`);

// 🔥 New: Start shuffled interview (same set but randomized)
// src/api/mockClient.js
export const shuffleInterview = (interviewId) =>
  api.post(`/mock/shuffle`, { interviewId });

export const createNewVersion = () => api.post("/mock/versions");
